/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HomeScrollSectionOne from "./HomeScrollSectionOne";
import HomeScrollSectionTwo from "./HomeScrollSectionTwo";
import HomeScrollSectionThree from "./HomeScrollSectionThree";
import HomeScrollSectionFour from "./HomeScrollSectionFour";
import Layout from "../../components/Layout/Layout";
import Header from "../../components/Layout/Header";

const components = [
    <HomeScrollSectionOne key="one" />,
    <HomeScrollSectionTwo key="two" />,
    <HomeScrollSectionThree key="three" />,
    <HomeScrollSectionFour key="four" />,
];

const NewHomePage = () => {
    const [currentComponentIndex, setCurrentComponentIndex] = useState(0);
    const [showBlackDivs, setShowBlackDivs] = useState(false);
    const [scrollDirection, setScrollDirection] = useState("forward");
    const [isScrolling, setIsScrolling] = useState(false);
    const [isAtBottom, setIsAtBottom] = useState(false);


    const handleScroll = (event) => {
        if (isScrolling) return;
        const isScrollingDown = event.deltaY > 0;
        if (isScrollingDown) {
            // if (currentComponentIndex === 3 && !isAtBottom) return;
            if (currentComponentIndex === 3) return;
            setScrollDirection("forward");
            setCurrentComponentIndex((prevIndex) => (prevIndex + 1) % components.length);
            setIsAtBottom(false);
        }
        else {
            // if (currentComponentIndex === 3 && !isAtBottom) return;
            if (currentComponentIndex === 3) return;
            setScrollDirection("backward");
            setCurrentComponentIndex((prevIndex) =>
                prevIndex === 0 ? components.length - 1 : prevIndex - 1
            );
            setIsAtBottom(false);
        }
        setShowBlackDivs(true);
        setIsScrolling(true);
        setTimeout(() => {
            setShowBlackDivs(false);
            setIsScrolling(false);
        }, 1000);
    };

    const slideInVariants = {
        forward: {
            initial: { x: "100%", opacity: 0 },
            animate: { x: 0, opacity: 1 },
            exit: { x: "-100%", opacity: 0 },
        },
        backward: {
            initial: { x: "-100%", opacity: 0 },
            animate: { x: 0, opacity: 1 },
            exit: { x: "100%", opacity: 0 },
        },
    };
    

    return (
        <>
            <div className="container-home" onWheel={handleScroll}>
                <Header setCurrentComponentIndex={setCurrentComponentIndex} />
                <AnimatePresence mode="wait">
                    {showBlackDivs && (
                        <>
                            <motion.div
                                className="black-div top"
                                initial={{ y: "-100%" }}
                                animate={{ y: 0 }}
                                exit={{ y: "-100%" }}
                                transition={{ duration: 1 }}
                            />
                            <motion.div
                                className="black-div bottom"
                                initial={{ y: "100%" }}
                                animate={{ y: 0 }}
                                exit={{ y: "100%" }}
                                transition={{ duration: 1 }}
                            />
                        </>
                    )}
                </AnimatePresence>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentComponentIndex}
                        variants={slideInVariants[scrollDirection]}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        transition={{ duration: 0.8 }}
                    >
                        {
                            currentComponentIndex === 0 ? <HomeScrollSectionOne /> : currentComponentIndex === 1 ? <HomeScrollSectionTwo /> : currentComponentIndex === 2 ? <HomeScrollSectionThree /> : <HomeScrollSectionFour isAtBottom={isAtBottom} setIsAtBottom={setIsAtBottom} />
                        }
                    </motion.div>
                </AnimatePresence>
            </div>
        </>
    );
};

export default NewHomePage;
